import { Page } from '@/components/page';
import { PuckPreviewWidget } from '@/features/populate/components/puck-preview-widget';
import { useSearchParams } from 'react-router-dom';

export function PuckPreviewScreen() {
  const [searchParams] = useSearchParams();
  const container = searchParams.get('container') ?? '';
  const uuid = searchParams.get('uuid') ?? '';

  return (
    <Page title="Preview">
      <PuckPreviewWidget container={container} uuid={uuid} />
    </Page>
  );
}
